import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-skeleton/dist/index.module.css';
export default function Skeleton(_ref) {
  let {
    count = 1,
    width = null,
    height = null,
    circle = false,
    animation = true,
    gradientColors = [],
    wrapper: Wrapper = null,
    style: customStyle = {},
    className: customClassName = ''
  } = _ref;
  const elements = [];
  for (let i = 0; i < count; i++) {
    let style = {};
    if (width !== null) {
      style.width = width;
    }
    if (height !== null) {
      style.height = height;
    }
    if (width !== null && height !== null && circle) {
      style.borderRadius = '50%';
    }
    const className = classNames({
      [styles['sib-skeleton']]: true,
      [styles['sib-skeleton-animation']]: animation,
      [customClassName]: !!customClassName
    });
    const gradientStyle = gradientColors.length === 2 ? {
      backgroundImage: `linear-gradient(to right, ${gradientColors[0]} 0%, ${gradientColors[1]} 20%, ${gradientColors[0]} 40%, ${gradientColors[0]} 100%)`
    } : {};
    elements.push(/*#__PURE__*/React.createElement("span", {
      key: i,
      className: className,
      style: {
        ...customStyle,
        ...style,
        ...gradientStyle
      }
    }, "\u200C"));
  }
  return Wrapper ? elements.map((element, i) => /*#__PURE__*/React.createElement(Wrapper, {
    key: i
  }, element, "\u200C")) : elements;
}
Skeleton.propTypes = {
  count: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  wrapper: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circle: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  animation: PropTypes.bool,
  gradientColors: PropTypes.arrayOf(PropTypes.string)
};